import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

export function useLastPromptPersistence(): useLastPromptPersistenceReturn {
  return useLazyContext(LastPromptPersistenceContext);
}

export const LastPromptPersistenceContext =
  createContext<LazyValue<useLastPromptPersistenceReturn>>(undefined);

export type useLastPromptPersistenceReturn = {
  getLastPrompted: () => Promise<Date | undefined>;
  setLastPrompted: (date: Date) => Promise<void>;
};
